import { Route, Switch } from "react-router-dom";

import AiNativeCurationFaireMcpDemoPage from "@faire/prototype-playground/workspace/pk/faire-mcp-curation";

export function PavloKuzhelRoutes() {
  return (
    <Switch>
      <Route path="/pk/faire-mcp-curation" component={AiNativeCurationFaireMcpDemoPage} />
    </Switch>
  );
}

export const slug = "pk";
